export default __webpack_public_path__ + "static/media/art-pro-red-banner-2.dec4269c.jpg";